import { useSearchParams } from "react-router";

const useLocalMode = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const localPort: any = searchParams.get("localPort");
  const localFilePath: any = searchParams.get("localFilePath");

  const isLocalMode: boolean = Boolean(localPort) && Boolean(localFilePath);

  return { isLocalMode, localPort, localFilePath };
};

export default useLocalMode;
